module.exports = __webpack_public_path__ + "static/Fotodokumentation der Kreativwerkstatt-45bac98cc3a2837c93c60c6902c8ad30.pdf";